var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0204 1.97998C14.9521 2.91162 14.9521 4.42211 14.0204 5.35375L6.04156 13.3326C5.85698 13.5172 5.62742 13.6504 5.37558 13.7191L1.96512 14.6492C1.59187 14.751 1.24938 14.4086 1.35118 14.0353L2.2813 10.6248C2.34999 10.373 2.48321 10.1434 2.66779 9.95887L10.6467 1.97998C11.5783 1.04834 13.0888 1.04834 14.0204 1.97998ZM10.0003 4.04058L3.3749 10.666C3.31337 10.7275 3.26896 10.804 3.24607 10.888L2.54617 13.4543L5.11246 12.7544C5.19641 12.7315 5.27293 12.6871 5.33446 12.6255L11.9597 5.99992L10.0003 4.04058ZM11.3538 2.68709L10.707 3.33325L12.6663 5.29325L13.3133 4.64665C13.8545 4.10553 13.8545 3.22821 13.3133 2.68709C12.7722 2.14597 11.8949 2.14597 11.3538 2.68709Z",
    fill: "#222729"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.6b8fdb8e8c17918a0aa13c58f2b5103f.svg";
export { ForwardRef as ReactComponent };